import React from "react";
import ComplianceAddons from "./ComplianceAddons/ComplianceAddons";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import AdditionalAddons from "./AdditionalAddons/AdditionalAddons";
import { SnackbarProvider } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { getAccountCloudType } from "../../../CloudProviderContext";

const addonCardSx = {
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.08)",
  p: 1.5,
  backgroundColor: "#fff",
  overflow: "hidden",
};

const AddonsManagement = (props) => {
  console.log("AddonsManagement is rerendered");
  const isAzureAccount = getAccountCloudType(props.editAccount) === "AZURE";
  return (
    <React.Fragment>
      <SnackbarProvider>
        <Modal
          isOpen={props.modal_addons}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader
            toggle={props.closeModal}
            style={{
              backgroundColor: "#F98125",
              margin: -1,
              display: "flex",
              alignItems: "center",
              minHeight: 56,
            }}
            close={
              <button
                type="button"
                aria-label="Close"
                onClick={props.closeModal}
                style={{
                  padding: 0,
                  margin: 0,
                  border: "none",
                  background: "transparent",
                  color: "#FFFFFF",
                  fontSize: 28,
                  fontWeight: 700,
                  lineHeight: 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  opacity: 1,
                  boxShadow: "none",
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            }
          >
            <Typography color="#FFFFFF" variant="h6">
              Add Ons List for Account Number:{" "}
              {props?.editAccount?.accountNumber}
            </Typography>
          </ModalHeader>
          <ModalBody
            style={{
              maxHeight: "70vh",
              overflowY: isAzureAccount ? "hidden" : "auto",
              ...(isAzureAccount && {
                display: "flex",
                flexDirection: "column",
              }),
            }}
          >
            {isAzureAccount ? (
              <Paper
                elevation={0}
                sx={{
                  ...addonCardSx,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                }}
              >
                <ComplianceAddons
                  complianceAddOns={props.complianceAddOns}
                  editAccount={props.editAccount}
                  isAzureAccount={isAzureAccount}
                />
              </Paper>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Paper elevation={0} sx={addonCardSx}>
                  <ComplianceAddons
                    complianceAddOns={props.complianceAddOns}
                    editAccount={props.editAccount}
                    isAzureAccount={isAzureAccount}
                  />
                </Paper>
                <Paper elevation={0} sx={addonCardSx}>
                  <AdditionalAddons
                    addOns={props.addOns}
                    editAccount={props.editAccount}
                    accounts={props.accounts}
                  />
                </Paper>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="btn w-lg btn-secondary"
              onClick={props.closeModal}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </SnackbarProvider>
    </React.Fragment>
  );
};

export default AddonsManagement;

// compliance_status, costInsight_status, costOptimization_status, eventInsight_status,
